import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { QuoteProvider } from "@/context/QuoteContext";
import Landing from "@/pages/Landing";
import ServiceDetail from "@/pages/ServiceDetail";
import ServicesIndex from "@/pages/ServicesIndex";
import LocationDetail from "@/pages/LocationDetail";
import AreasIndex from "@/pages/AreasIndex";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import QuoteLanding from "@/pages/QuoteLanding";
import ThankYou from "@/pages/ThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSeo from "@/pages/AdminSeo";
import AdminContent from "@/pages/AdminContent";
import AdminProjects from "@/pages/AdminProjects";
import AdminReviews from "@/pages/AdminReviews";
import AdminGuides from "@/pages/AdminGuides";
import AdminOpportunities from "@/pages/AdminOpportunities";
import AdminLeads from "@/pages/AdminLeads";
import AdminAds from "@/pages/AdminAds";
import GuideIndex from "@/pages/GuideIndex";
import GuideArticle from "@/pages/GuideArticle";
import NotFound from "@/pages/NotFound";
import ProjectDetail from "@/pages/ProjectDetail";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <QuoteProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/services" element={<ServicesIndex />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/tiling/:suburb" element={<LocationDetail />} />
              <Route path="/areas" element={<AreasIndex />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote" element={<QuoteLanding />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/projects/:slug" element={<ProjectDetail />} />
              <Route path="/guide" element={<GuideIndex />} />
              <Route path="/guide/:slug" element={<GuideArticle />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/seo" element={<AdminSeo />} />
              <Route path="/admin/content" element={<AdminContent />} />
              <Route path="/admin/projects" element={<AdminProjects />} />
              <Route path="/admin/reviews" element={<AdminReviews />} />
              <Route path="/admin/guides" element={<AdminGuides />} />
              <Route path="/admin/opportunities" element={<AdminOpportunities />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/admin/ads" element={<AdminAds />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </QuoteProvider>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
